import type { CaptureResult, Properties } from "posthog-js";

// The URL rides on every event: strip emailed credentials (token, code), a C2C key pasted onto the app host
// (api_key) and the number a C2C link dials (destination), in any encoding.
const URL_PROPERTIES = ["$current_url", "$pathname", "$referrer", "$initial_current_url", "$session_entry_url"];
// A redirect carries its target percent encoded (/login?from=%2Fc2c%3Fdestination%3D...), maybe more than once, so
// each separator matches raw or as %3F, %26, %3D, %23 behind any number of %25 layers.
const encoded = (hex: string) => `%(?:25)*(?:${hex})`;
const START = `(?:[?&]|${encoded("3F|26")})`;
const EQUALS = `(?:=|${encoded("3D")})`;
const END = `(?:[&#]|${encoded("26|23")})`;
const SENSITIVE_PARAM = new RegExp(`(${START}(?:token|code|api_key|destination)${EQUALS})(?:(?!${END}).)*`, "gi");

function redactUrls(properties: Properties | undefined) {
    for (const key of URL_PROPERTIES) {
        const value = properties?.[key];
        if (properties && typeof value === "string") {
            properties[key] = value.replace(SENSITIVE_PARAM, "$1<redacted>");
        }
    }
}

/** PostHog's before_send: the event with those query values replaced, in its properties and the person properties
 *  it sets. */
export function redactSensitiveUrls(event: CaptureResult | null): CaptureResult | null {
    if (!event) {
        return event;
    }
    [event.properties, event.$set, event.$set_once].forEach(redactUrls);
    return event;
}
